import { render, staticRenderFns } from "./DynamicContentTable.vue?vue&type=template&id=fd19413c"
import script from "./DynamicContentTable.vue?vue&type=script&lang=js"
export * from "./DynamicContentTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicContentTable.vue?vue&type=style&index=0&id=fd19413c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports